import createParseMiddleware from './createParseMiddleware';
import { parseLocationResponse, parseLocationWorkflowResponse } from 'utils/apiParser/locationParser';
import { Location, LocationWorkflow } from 'types/locationTypes';

export const parseFetchLocationsMiddleware = createParseMiddleware<Location>(parseLocationResponse, 'locations/fetchLocations');
export const parseDescribeLocationMiddleware = createParseMiddleware<Location>(parseLocationResponse, 'locations/describeLocation');
export const parseDescribeLocationWorkflowMiddleware = createParseMiddleware<LocationWorkflow>(parseLocationWorkflowResponse, 'locations/describeLocationWorkflow');
